import React from 'react';
import { createUseStyles } from 'react-jss';

function SearchCat3(props) {
const st=styles();
  return (
    <div className={st.container}>SearchCat1</div>
  );
}

const styles = createUseStyles({
  container: {}
});

export default SearchCat3;